// importing reg components

import Registration from './registration'
import RegInstructions from './regInstructions'

export default [
  {
    path: `/platinum-reasoning-contest-2018-register-candidate*`,
    name: 'Application for Platinum Reasoning Contest 2018(PRC2018) || PMGC',
    component: Registration
  },
  {
    path: `/platinum-reasoning-contest-2018-registration-instructions*`,
    name: 'Application for Platinum Reasoning Contest 2018 || Instructions for PRC2018',
    component: RegInstructions
  }
]



// WEBPACK FOOTER //
// ./src/pmgc/registration/router.js